import type { HTMLAttributes, ReactNode } from 'react';

import type { SpacingType } from '@zoomit/primitives';
import { Box, cn } from '@zoomit/primitives';

type Props = {
  spacing?: SpacingType;
  children?: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

const ModuleTitle = (props: Props) => {
  const { spacing, children, className, ...rest } = props;

  return (
    <Box spacing={{ pr: 'x4', ...spacing }}>
      <Box
        className={cn(
          'before:bg-primary1 relative before:absolute before:top-0 before:-right-4 before:h-full before:w-1',
          className,
        )}
        {...rest}
      >
        {children}
      </Box>
    </Box>
  );
};

export default ModuleTitle;
